<template>
    <!-- 基站预警页面  stationEarlywarning.vue -->
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                基站告警
                <small>基站告警</small>
            </h1>
            <ol class="breadcrumb">
                <li>
                    <a href="#">
                        <i class="fa fa-dashboard"></i> 基站告警
                    </a>
                </li>
                <li class="active">基站告警</li>
            </ol>
        </section>
        <!-- Main content -->
        <section class="content">
            <!-- Main row -->
            <div class="row col-sm-12">
                <div id="atptoolbar">
                    <button class="btn btn-info" type="button" id="sys_detai" @click="cancel">
                        <i class="fa fa-sign-in"></i>&nbsp;取消告警
                    </button>
                    <button class="btn btn-info" type="button" id @click="seeGraph">
                        <i class="fa fa-sign-in"></i>&nbsp;实时功率图
                    </button>
                </div>
                <table id="warn_atptable"></table>
            </div>
            <!-- /.row (main row) -->
        </section>
        <!-- /.content -->
        <v-ammetersmart :msg-ammeterid="ammeterid" ref="ammetersmart"></v-ammetersmart>
    </div>
</template>

<script>
  import ammetersmart from '../ammeter/ammetersmart'

  export default {
    name: '',
    data () {
      return {
        org_id: '', //公司id
        ammeterid: '',
      }
    },
    components: { 'v-ammetersmart': ammetersmart },
    mounted: function () {
      var self = this
      var org_id = JSON.parse(localStorage.getItem('companyInfo')).id
      self.org_id = org_id
      self.getData()
    },
    methods: {
      getData: function () {
        var self = this
        $('#warn_atptable').bootstrapTable({
          url:
            self.global.apiHost +
            'organizations/' +
            self.org_id +
            '/events/?type=1', //请求后台的URL（*）
          method: 'get', //请求方式（*）
          ajaxOptions: {
            headers: {
              'content-type': 'application/json', // 默认值
              Authorization: 'Bearer ' + localStorage.getItem('access_token')
            }
          },
          toolbar: '#atptoolbar', //工具按钮用哪个容器
          height: $(window).height() * 0.86,
          striped: true, //是否显示行间隔色
          cache: false, //是否使用缓存，默认为true，所以一般情况下需要设置一下这个属性（*）
          pagination: true, //是否显示分页（*）
          iconSize: 'outline',
          sortable: true, //是否启用排序
          sortName: 'stst_atpid',
          sortOrder: 'DESC', //排序方式
          queryParams: self.queryParams, //传递参数（*）
          sidePagination: 'server', //分页方式：client客户端分页，server服务端分页（*）
          pageNumber: 1, //初始化加载第一页，默认第一页
          pageSize: 15, //每页的记录行数（*）
          pageList: [15], //可供选择的每页的行数（*）
          search: true, //是否显示表格搜索，此搜索是客户端搜索，不会进服务端，所以，个人感觉意义不大
          showColumns: true, //是否显示所有的列
          showRefresh: true, //是否显示刷新按钮
          minimumCountColumns: 2, //最少允许的列数
          clickToSelect: true, //是否启用点击选中行
          singleSelect: false, // 是否启用单选
          uniqueId: 'id', //每一行的唯一标识，一般为主键列
          responseHandler: function (res) {
            return {
              total: res.total, //总页数
              rows: res.rows //数据
            }
          },
          columns: [
            [
              { checkbox: true },
              {
                title: '序号',
                width: 40,
                formatter: function (value, row, index) {
                  var option = $('#warn_atptable').bootstrapTable('getOptions')
                  return option.pageSize * (option.pageNumber - 1) + index + 1
                }
              },
              {
                field: 'stst_commname',
                title: '基站名称',
                sortable: true
              },
              {
                field: 'stst_comm',
                title: '运营商',
                sortable: true
              },
              {
                field: 'message',
                title: '告警信息',
                sortable: true
              },
              {
                field: 'create_time',
                title: '创建时间',
                sortable: true
              }
            ]
          ]
        })
      },
      queryParams: function (params) {
        params.per_page = params.limit
        params.page = params.offset / params.limit + 1
        return params
      },
      // 查看折线图
      seeGraph: function () {
        var self = this
        var selectOption = $('#warn_atptable').bootstrapTable('getSelections')
        if (selectOption.length != 1) {
          alert('只能选择一条数据')
        } else {
          if (selectOption[0].extra_information.indexOf('ammeter_id') > 1) {
            self.ammeterid = JSON.parse(selectOption[0].extra_information).ammeter_id
            $('#sys_device_modal').modal('show')
            setTimeout(function () {
              self.$refs['ammetersmart'].intfunc() // 调用子组件函数
            }, 1000)
          } else {
            alert('警告:无法关联到电表')
          }
        }
      },
      // 取消告警
      cancel: function () {
        var self = this
        var putData = []
        var putlist = $('#warn_atptable').bootstrapTable('getSelections')
        for (var i = 0; i < putlist.length; i++) {
          putData.push(putlist[i].id)
        }
        self.global.axiosPut(
          self,
          'organizations/' + self.org_id + '/events/',
          putData,
          function (res) {
            if (res.status == 'success') {
              alert('操作成功')
              $('#warn_atptable').bootstrapTable('refresh')
            } else {
              alert('操作失败!')
            }
          },
          function () {
            alert('操作失败')
          }
        )
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/stationManager/stationAlarm.vue